export const UNCLOSED_DATES_REPORT_FETCHING = 'UNCLOSED_DATES_REPORT_FETCHING';
export const UNCLOSED_DATES_REPORT_FETCH_ERROR =
  'UNCLOSED_DATES_REPORT_FETCH_ERROR';
export const UNCLOSED_DATES_REPORT_GET_REPORT =
  'UNCLOSED_DATES_REPORT_GET_REPORT';



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/state/uncloseddatesreport/types.js